import { defineComponent as _defineComponent } from 'vue'
import {useTranslations} from "@/hooks/useTranslations";
import {ref, watch} from "vue";

type NotificationEmailFormProps = {
  value: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationEmailForm',
  props: {
    value: null
  },
  emits: ["update:value"],
  setup(__props: any, { emit }) {

const props = __props as {
  value: string;
};




const translations = useTranslations();
const modelValue = ref<string>(props.value);

watch(modelValue, (newValue) => {
  emit("update:value", newValue);
});

return { __sfc: true,props, emit, translations, modelValue }
}

})